import React from 'react'

import { TableEmptyBox } from '@fielded/shared-ui'
import { Download } from '@fielded/shared-ui/src/icons'

const HomeStockReportsTableEmptyInfo = ({ loading, isSingleView }) => {
  let mainCopy = 'No reports available yet'
  let supportingCopy = 'Reports are prepared daily and will appear here once ready.'

  if (isSingleView) {
    mainCopy = 'No reports prepared yet'
    supportingCopy = 'Select a branch above to prepare data and generate your report.'
  }

  return (
    <TableEmptyBox
      loading={loading}
      mainCopy={mainCopy}
      supportingCopy={supportingCopy}
      icon={<Download />}
    />
  )
}

export default HomeStockReportsTableEmptyInfo
